import styled from 'styled-components';

export const UiRadioBox = styled.div`
display: flex;
`;
